import React from 'react'
import NewUser from '../components/login/NewUser'

function CreateUser() {
  return (
    <NewUser/>
  )
}

export default CreateUser